import { render, staticRenderFns } from "./CheckEmailConfirmCode.vue?vue&type=template&id=5cc972c3&"
import script from "./CheckEmailConfirmCode.vue?vue&type=script&lang=js&"
export * from "./CheckEmailConfirmCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports